import { Customer } from '../types/types'
// Save customers to localStorage
export const saveCustomers = (customers: Customer[]): void => {
  localStorage.setItem('customers', JSON.stringify(customers))
}
// Load customers from localStorage
export const loadCustomers = (): Customer[] => {
  const storedCustomers = localStorage.getItem('customers')
  if (!storedCustomers) return []
  return JSON.parse(storedCustomers)
}
